import { Extensions, getSchema } from '@tiptap/core';
import { Color } from '@tiptap/extension-color';
import { Subscript } from '@tiptap/extension-subscript';
import { Superscript } from '@tiptap/extension-superscript';
import { Schema } from '@tiptap/pm/model';
import { StarterKit } from '@tiptap/starter-kit';
import { CustomBulletList } from './extensions/custom-bullet-list';
import { CustomListItem } from './extensions/custom-list-item';
import { CustomOrderedList } from './extensions/custom-ordered-list';
import { decorateSelection } from './extensions/decorateSelection';
import { fillInTheBlanksBaseExtension } from './extensions/fill-in-the-blanks-base-extension';
import { FontFamily } from './extensions/font-family';
import { FontSizeExtension } from './extensions/font-size';
import { Heading } from './extensions/heading';
import { Link } from './extensions/link';
import { ListKeymap } from './extensions/list-key-item';
import { Shadow } from './extensions/shadow';
import { Strike } from './extensions/strike';
import { TextStyle } from './extensions/text-style';
import { Underline } from './extensions/underline';

export const tipTapLeanExtensions: Extensions = [
  StarterKit.configure({
    history: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    strike: false,
    bold: false,
    blockquote: false,
    heading: false,
    horizontalRule: false,
    code: false,
    codeBlock: false,
    italic: false,
  }),
];

/** implicit Text component list, should be improved in a follow up PR */
export const tipTapBaseExtensions: Extensions = [
  StarterKit.configure({
    history: false,
    bulletList: false,
    orderedList: false,
    listItem: false,
    strike: false,
    heading: false,
  }),
  TextStyle,
  Heading,
  Underline,
  CustomListItem,
  CustomOrderedList,
  CustomBulletList,
  ListKeymap,
  FontSizeExtension,
  FontFamily.configure({
    types: ['textStyle'],
  }),
  Strike,
  Color,
  Shadow,
  decorateSelection,
  Subscript,
  Superscript,
  Link.configure({
    defaultProtocol: 'https',
    autolink: false,
  }),
];

/** TipTap full list should include all extensions that are stored in the database in any TipTap content */
export const tipTapExtensionsFullList: Extensions = [...tipTapBaseExtensions, fillInTheBlanksBaseExtension];

export const tipTapSchema: Schema = getSchema(tipTapExtensionsFullList);
